module.exports = __webpack_public_path__ + "mx.svg?1fcc3cf0c7e6ca135612d8b3ed399e3a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/mx.svg
// module id = 1267
// module chunks = 0